#import "../fragments/availability-report-fragment.graphql"

query GetAvailabilityReport($meetingId: ID!, $periodString: String) {
    availabilityReport(meetingId: $meetingId, periodString: $periodString) {
        ...AvailabilityReportFragment
    }
}
